! function() {
    "use strict";
    var e, t = {
            4487: function(e, t, r) {
                var n = r(6072);
                const i = new class {
                    constructor() {
                        this.items = Array.from(document.querySelectorAll(".cart-item")), this.items.forEach((e => this.manageState(e))), this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"], this.mainCartSelector = ".shopify-section.cart", this.miniCart = document.getElementById("mini-cart"), this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty", this.parser = new DOMParser
                    }
                    manageState(e) {
                        const t = e.getAttribute("data-variant-id");
                        e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click", (async () => {
                            await this.changeCartItem({
                                id: t,
                                quantity: 0
                            }), e.remove()
                        }));
                        const r = e.querySelector('input[name="quantity"]');
                        if (!r) return;
                        const n = e.querySelector('button[name="plus"]'),
                            i = e.querySelector('button[name="minus"]'),
                            s = e.querySelector('input[name="quantity"]');
                        let o = parseInt(r.value);
                        n.addEventListener("click", (() => {
                            o += 1, r.value = o, this.changeCartItem({
                                id: t,
                                quantity: o
                            })
                        })), i.addEventListener("click", (() => {
                            o -= 1, r.value = o, this.changeCartItem({
                                id: t,
                                quantity: o
                            })
                        })), s.addEventListener("change", (e => {
                            parseInt(e.target.value) > 0 ? (o = parseInt(e.target.value), this.changeCartItem({
                                id: t,
                                quantity: o
                            })) : s.value = o
                        })), s.addEventListener("keypress", (e => {
                            (8 !== e.which && 0 !== e.which && e.which < 48 || e.which > 57) && e.preventDefault()
                        }))
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, n.Q2)(),
                            body: JSON.stringify({
                                line: +e.id,
                                quantity: e.quantity,
                                sections: "main-cart"
                            })
                        };
                        fetch(`${routes.cartChange}`, t).then((e => e.json())).then((e => {
                            const t = t => {
                                const r = this.parser.parseFromString(t, "text/html");
                                if (0 === e.item_count) {
                                    const e = document.querySelector(this.mainCartSelector);
                                    e && (e.innerHTML = r.querySelector(this.mainCartSelector).innerHTML), this.renderElements(r)
                                } else this.renderItems(r)
                            };
                            if (e.sections && null !== e.sections["main-cart"]) t(e.sections["main-cart"]);
                            else {
                                const e = `${window.location.pathname}?section_id=main-cart`;
                                fetch(e).then((e => e.text())).then((e => {
                                    t(e)
                                }))
                            }
                            const r = `${window.location.pathname}?section_id=navigation-main`;
                            fetch(r).then((e => e.text())).then((t => {
                                const r = this.parser.parseFromString(t, "text/html");
                                if (0 === e.item_count) {
                                    const e = document.querySelector("#mini-cart");
                                    e && (e.innerHTML = r.querySelector("#mini-cart").innerHTML, e.addEventListeners(), e.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))))
                                }
                            }))
                        })).catch((e => {
                            console.error(e)
                        }))
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t => {
                            try {
                                const r = document.querySelectorAll(t),
                                    n = e.querySelector(t);
                                r.length && n && r.forEach((e => {
                                    n.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))), e.replaceWith(n.cloneNode(!0))
                                }))
                            } catch (e) {
                                console.error(`Error updating ${t}`, e)
                            }
                        }));
                        const t = e.querySelector(".cart-count");
                        document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach((e => {
                            t ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"), e.textContent = t.textContent) : e.classList.add("visually-hidden")
                        })), document.querySelector("#cart-open-block .icon").classList.add("loaded")
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            r = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e => {
                            e && e.replaceWith(r.cloneNode(!0))
                        })), document.querySelectorAll(".cart-item").forEach((e => {
                            e.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))), this.manageState(e)
                        }))
                    }
                    updateMiniCart(e) {
                        return fetch("/?section_id=main-cart").then((e => e.text())).then((t => {
                            this.renderItems((new DOMParser).parseFromString(t, "text/html")), e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open()
                        })).catch((e => {
                            console.error("Error updating mini cart:", e)
                        }))
                    }
                };
                t.Z = i, customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
                    constructor() {
                        super(), this.querySelector("textarea").addEventListener("change", (0, n.Ds)((e => {
                            const t = JSON.stringify({
                                note: e.target.value
                            });
                            fetch(`${routes.cartUpdate}`, {
                                ...(0, n.Q2)(),
                                body: t
                            })
                        }), 300))
                    }
                })
            },
            9893: function(e, t, r) {
                var n = r(3643),
                    i = r(1717);
                const s = e => {
                        const t = e.dataset.url;
                        fetch(t).then((e => e.text())).then((t => {
                            const r = document.createElement("div");
                            r.innerHTML = t;
                            const s = r.querySelector(".product-recommendations");
                            if (s && s.innerHTML.trim().length) {
                                const t = e.closest(".shopify-section");
                                t.classList.add("u-hide"), e.innerHTML = s.innerHTML, new n.M, (0, i.f)(), setTimeout((() => {
                                    window.matchHeightCallback && typeof window.matchHeightCallback === "function" && window.matchHeightCallback()
                                }), 1.5e3), setTimeout((() => {
                                    t.classList.remove("u-hide")
                                }), 1e3)
                            }
                        })).catch((e => {
                            console.error(e)
                        }))
                    },
                    o = document.querySelectorAll(".product-recommendations"),
                    a = new IntersectionObserver(((e, t) => {
                        e.forEach((e => {
                            e.isIntersecting && (t.unobserve(e.target), s(e.target))
                        }))
                    }), {
                        rootMargin: "0px 0px 200px 0px"
                    });
                o.forEach((e => {
                    a.observe(e)
                })), Shopify.designMode && document.addEventListener("shopify:section:load", (() => {
                    o.forEach((e => {
                        s(e)
                    }))
                }))
            },
            1717: function(e, t, r) {
                r.d(t, {
                    f: function() {
                        return s
                    }
                });
                var n = r(6072),
                    i = r(4487);
                const s = () => {
                    const e = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
                        t = document.getElementById("main-cart"),
                        r = document.getElementById("mini-cart"),
                        s = document.querySelector("body");
                    e.length && e.forEach((e => e.addEventListener("submit", (o => {
                        if (o.target.dataset.sub) return;
                        o.target.dataset.sub = 1;
                        setTimeout(() => o.target.dataset.sub = '', 100);
                        o.preventDefault(), o.stopPropagation(), o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`);
                        const a = o.target.querySelector('button[type="submit"]'),
                            c = a.querySelector("span.cart-icon"),
                            l = a.querySelector("svg.loading-icon");
                        s.classList.remove("added-to-cart"), a.classList.add("added"), c.style.display = "none", l.style.display = "block";
                        const d = (0, n.Q2)("javascript");
                        d.headers["X-Requested-With"] = "XMLHttpRequest", delete d.headers["Content-Type"];
                        const u = new FormData(e);
                        u.append("sections", "main-cart"), d.body = u, fetch(`${routes.cartAdd}`, d).then((e => e.json())).then((async e => {
                            if (e.status) {
                                if (i.Z.updateMiniCart(!0), c.style.display = "inline-flex", l.style.display = "none", o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`), "object" == typeof e.description) return Object.entries(e.description).forEach((e => {
                                    let [t, r] = e;
                                    const n = `${r.join(", ")}`;
                                    o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + n + "</p>"
                                }));
                                o.target.querySelector(".main-product__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>"
                            } else {
                                if ("cart" === cartStrings.uxCart) return void(window.location.href = window.routes.cart);
                                if (o.target.querySelector(".main-product__error").innerHTML = "", t && t.classList.add("added"), e.sections && null !== e.sections["main-cart"]) i.Z.renderItems((new DOMParser).parseFromString(e.sections["main-cart"], "text/html"));
                                else {
                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                    fetch(e).then((e => e.text())).then((e => {
                                        i.Z.renderItems((new DOMParser).parseFromString(e, "text/html"))
                                    }))
                                }
                                "mini-cart" === cartStrings.uxCart && r && r.open(), o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') && (o.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`), a.classList.remove("added"), a.classList.add("successful"), c.style.display = "flex", l.style.display = "none", s.classList.add("added-to-cart")
                            }
                        })).catch((e => {
                            console.error("Error:", e)
                        }))
                    }))))
                }
            },
            3643: function(e, t, r) {
                r.d(t, {
                    M: function() {
                        return n
                    }
                }), (0, r(8464).z2)();
                class n {
                    constructor() {
                        this.initializeSwipers(), Shopify.designMode && document.addEventListener("shopify:section:load", (() => this.initializeSwipers()))
                    }
                    initializeSwipers() {
                        document.querySelectorAll("swiper-container").forEach((e => {
                            e.dataset.mobileSlidesPerView;
                            const t = (e.dataset.desktopSlidesPerView, "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView, "true" === e.dataset.textPagination),
                                r = Number(e.dataset.spaceBetweenMobile) || 16,
                                n = Number(e.dataset.spaceBetweenTablet) || 32,
                                i = Number(e.dataset.spaceBetweenDesktop) || 32,
                                s = e.dataset.mobileLayout || "slider",
                                o = e.dataset.desktopLayout || "slider",
                                a = window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
                                c = window.matchMedia("(min-width: 1024px)"),
                                l = () => {
                                    e.querySelectorAll("video").forEach((e => {
                                        e.classList.contains("section__wrapper-background") || e.pause()
                                    })), Array.from(e.querySelectorAll("swiper-slide")).filter((e => e.classList.contains("swiper-slide-visible"))).forEach((e => {
                                        const t = e.querySelector("video");
                                        t && t.hasAttribute("autoplay") && t.play()
                                    }))
                                },
                                d = () => {
                                    const t = e.closest(".slideshow-text-controls__wrapper");
                                    if (!t) return;
                                    const r = e.swiper.slides[e.swiper.realIndex];
                                    if (!r) return;
                                    const n = r.getAttribute("data-slide");
                                    t.querySelectorAll(".slideshow-text-controls__item").forEach((e => {
                                        e.classList.toggle("active", e.getAttribute("data-slide") === n)
                                    }))
                                },
                                u = () => {
                                    if (c.matches && "slider" === o || a.matches && "slider" === s)
                                        if (!e.swiper || e.swiper.destroyed) {
                                            var u;
                                            const s = parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                                                o = "0" !== e.dataset.tabletSlidesPerView && e.dataset.tabletSlidesPerView ? parseFloat(e.dataset.tabletSlidesPerView) : s,
                                                a = parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                                                c = {
                                                    ...null !== (u = e.parentElement) && void 0 !== u && u.classList.contains("card__image") ? {
                                                        virtual: {
                                                            enabled: !0
                                                        },
                                                        nested: !0
                                                    } : {},
                                                    breakpoints: {
                                                        0: {
                                                            slidesPerView: s,
                                                            spaceBetween: parseInt(r)
                                                        },
                                                        768: {
                                                            slidesPerView: o,
                                                            spaceBetween: parseInt(n)
                                                        },
                                                        1024: {
                                                            slidesPerView: a,
                                                            spaceBetween: parseInt(i)
                                                        }
                                                    }
                                                };
                                            Object.assign(e, c), e.addEventListener("swiperafterinit", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.add("slider-enabled"), setTimeout((() => {
                                                    var t, r;
                                                    if (!e.swiper) return;
                                                    const n = (null === (t = e.swiper) || void 0 === t || null === (r = t.slides) || void 0 === r ? void 0 : r.length) || 0,
                                                        i = n < s ? n : s,
                                                        c = n < o ? n : o,
                                                        d = n < a ? n : a;
                                                    e.swiper && e.swiper.params && e.swiper.params.breakpoints && (e.swiper.currentBreakpoint = !1, e.swiper.params.breakpoints[0].slidesPerView = i, e.swiper.params.breakpoints[768].slidesPerView = c, e.swiper.params.breakpoints[992].slidesPerView = d, e.swiper.update(), e.swiper.slideTo(0, 0, !1)), l(), (() => {
                                                        var t;
                                                        const r = null === (t = e.closest(".main-product__media-wrapper")) || void 0 === t ? void 0 : t.querySelector(".swiper-thumbnails .swiper");
                                                        r && (Object.assign(r, {
                                                            direction: "vertical",
                                                            slidesPerView: "auto",
                                                            spaceBetween: 8,
                                                            watchSlidesProgress: !0,
                                                            navigation: {
                                                                nextEl: ".swiper-button-thumbs-next",
                                                                prevEl: ".swiper-button-thumbs-prev"
                                                            },
                                                            breakpoints: {
                                                                0: {
                                                                    direction: "horizontal",
                                                                    slidesPerView: 4
                                                                },
                                                                768: {
                                                                    direction: "vertical",
                                                                    slidesPerView: "auto"
                                                                }
                                                            }
                                                        }), r.initialize())
                                                    })()
                                                }), 0)
                                            })), e.addEventListener("swiperslidechange", (() => {
                                                l(), d()
                                            })), e.addEventListener("swiperdestroy", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && t.classList.remove("slider-enabled")
                                            })), e.addEventListener("swiperlock", (() => {
                                                const t = e.closest(".shopify-section");
                                                t && !t.classList.contains("recommended-products") && setTimeout((() => {
                                                    t.querySelectorAll(".grid-content__slider-nav").forEach((e => {
                                                        e.style.display = "none"
                                                    }))
                                                }), 1)
                                            })), e.initialize(), t && ((() => {
                                                if (!t) return;
                                                const r = e.closest(".slideshow-text-controls__wrapper");
                                                r && r.querySelectorAll(".slideshow-text-controls__item").forEach((t => {
                                                    t.addEventListener("click", (() => {
                                                        const r = t.getAttribute("data-slide"),
                                                            n = Array.from(e.swiper.slides).findIndex((e => e.getAttribute("data-slide") === r)); - 1 !== n && e.swiper.slideTo(n)
                                                    }))
                                                }))
                                            })(), d())
                                        } else e.swiper.update();
                                    else if (Object.assign(e), e.initialize(), e.swiper) {
                                        e.swiper.destroy(!0, !0);
                                        const t = e.closest(".shopify-section");
                                        t && t.classList.remove("slider-enabled")
                                    }
                                };
                            window.addEventListener("resize", u), u()
                        }))
                    }
                }
                new n
            },
            6072: function(e, t, r) {
                r.d(t, {
                    Ds: function() {
                        return i
                    },
                    Q2: function() {
                        return n
                    }
                });
                const n = function() {
                    return {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/${arguments.length>0&&void 0!==arguments[0]?arguments[0]:"json"}`
                        }
                    }
                };

                function i(e, t) {
                    const r = this;
                    let n;
                    return function() {
                        for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++) s[o] = arguments[o];
                        clearTimeout(n), n = setTimeout((function() {
                            return e.apply(r, s)
                        }), t)
                    }
                }
                document.querySelectorAll(".local-scroll").forEach((e => {
                    e.addEventListener("click", (e => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        ! function(e) {
                            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            const r = document.getElementById("nav-wrapper"),
                                n = document.querySelector(".header").getAttribute("data-ux-position"),
                                i = e.getBoundingClientRect().top;
                            window.scrollTo({
                                top: "off" !== n ? i + window.scrollY - t + parseFloat(r.style.marginTop) : i + window.scrollY - t,
                                behavior: "smooth"
                            })
                        }(document.querySelector(t))
                    }))
                }))
            }
        },
        r = {};

    function n(e) {
        var i = r[e];
        if (void 0 !== i) return i.exports;
        var s = r[e] = {
            exports: {}
        };
        return t[e](s, s.exports, n), s.exports
    }
    n.m = t, e = [], n.O = function(t, r, i, s) {
            if (!r) {
                var o = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    r = e[d][0], i = e[d][1], s = e[d][2];
                    for (var a = !0, c = 0; c < r.length; c++)(!1 & s || o >= s) && Object.keys(n.O).every((function(e) {
                        return n.O[e](r[c])
                    })) ? r.splice(c--, 1) : (a = !1, s < o && (o = s));
                    if (a) {
                        e.splice(d--, 1);
                        var l = i();
                        void 0 !== l && (t = l)
                    }
                }
                return t
            }
            s = s || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
            e[d] = [r, i, s]
        }, n.d = function(e, t) {
            for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            })
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, n.j = 6184,
        function() {
            var e = {
                6184: 0,
                7658: 0,
                7954: 0,
                9217: 0,
                3625: 0
            };
            n.O.j = function(t) {
                return 0 === e[t]
            };
            var t = function(t, r) {
                    var i, s, o = r[0],
                        a = r[1],
                        c = r[2],
                        l = 0;
                    if (o.some((function(t) {
                            return 0 !== e[t]
                        }))) {
                        for (i in a) n.o(a, i) && (n.m[i] = a[i]);
                        if (c) var d = c(n)
                    }
                    for (t && t(r); l < o.length; l++) s = o[l], n.o(e, s) && e[s] && e[s][0](), e[s] = 0;
                    return n.O(d)
                },
                r = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
            r.forEach(t.bind(null, 0)), r.push = t.bind(null, r.push.bind(r))
        }();
    var i = n.O(void 0, [1216], (function() {
        return n(9893)
    }));
    i = n.O(i)
}();